import React, { Fragment, useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft, faDownload, faMoneyBillTransfer, faSackXmark } from "@fortawesome/free-solid-svg-icons";
import FiltersPartial from "./FiltersPartial.js";
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import RejectModal from "./RejectModal.js";
import ApproveModal from "./ApproveModal.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  const [filtersModel, setFiltersModel] = useState({})
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Tally Account Id',
      attr: 'tally_account_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Tally Transaction Number',
      value: (row) => {
        return <div style={{ cursor: 'pointer' }}>
          {row.tally_transaction_number} &ensp;
          {row.uploaded_file && <a target="_blank" rel="noreferrer" href={row.uploaded_file?.url}>
            <FontAwesomeIcon icon={faDownload} />
          </a>}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Tally Invoice Id',
      attr: 'tally_invoice_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Type',
      value: (row)=>`${row.transaction_type} ${row.transactn}`,
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      value: (row) => {
          if(row.status === 'approved'){
            return <span className="text-success">
              <FontAwesomeIcon icon={faMoneyBillTransfer} className="me-2"/>{row.status}
            </span>
          } else if(row.status === 'pending'){
            return <span className="text-warning">
              <FontAwesomeIcon icon={faClockRotateLeft} className="me-2"/>{row.status}
            </span>
          } else if(row.status === 'rejected'){
            return <span className="text-danger">
              <FontAwesomeIcon icon={faSackXmark} className="me-2"/>{row.status}
            </span>
          }
        }
    },
    {
      ...defaultHeaderConfig,
      label: 'SLOC',
      attr: 'service_location_location'
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction Date',
      attr: 'tally_transaction_date_time',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Remarks',
      attr: 'remarks'
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        if(row.status === 'pending'){
          return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.approve_tally_transaction.name)}>
              <div style={{cursor: 'pointer'}} onClick={(e) => onApproveClick(row) }>
                <button type="button" className="font-size-12 mx-2 rounded-2 add-button">Approve</button>
              </div>
            </UiAction>
            <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.reject_tally_transaction.name)}>
              <div style={{cursor: 'pointer'}} onClick={(e) => onRejectClick(row) }>
                <button type="button" className="font-size-12 mx-2 rounded-2 remove-button">Reject</button>
              </div>
            </UiAction>
          </div>
        }
      },
      disableSort: true,
    }
  ]

  const onApproveClick = (TransactionDetails) => {
    setTransactionDetails(TransactionDetails)
    setShowApproveModal(true);
  }

  const onRejectClick = (TransactionDetails) => {
    setTransactionDetails(TransactionDetails)
    setShowRejectModal(true);
  }

  return <>
    <Fragment>
      <RejectModal transactionDetails={transactionDetails} showRejectModal={showRejectModal} setShowRejectModal={setShowRejectModal}/>
    </Fragment>
    <Fragment>
      <ApproveModal transactionDetails={transactionDetails} showApproveModal={showApproveModal} setShowApproveModal={setShowApproveModal}/>
    </Fragment>
    <ListingPageComponent
    key={PAGES.TallyTransactionsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.TallyTransactionsListingPage.name)}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Tally Transactions' }]}
    listingMutation={getApi('tallyTransactions')}
    className="tally_transactions-listing-page"
    contentHeading="Tally Transactions List - Results"
    headers={headers}
    recordsKey="tally_transactions"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'Tally Transaction Number', 'Tally Invoice Id']}
  />
  </>
};

export default Index;
